/* src/app/components/ai-assist/live-speak-assist/live-speak-assist.component.scss */
.live-speak-assist-container {
  padding: 20px;
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
}
.voice-assistant-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
.main-content-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  position: relative;
  min-height: 400px;
  background: #f0f2f5;
}
.voice-input-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  animation: fadeIn 0.3s ease-in;
}
.voice-input-indicator .listening-animation {
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
}
.voice-input-indicator .wave {
  width: 8px;
  height: 40px;
  background: #133aa5;
  border-radius: 4px;
  animation: waveAnimation 1.2s ease-in-out infinite;
}
.voice-input-indicator .wave:nth-child(1) {
  animation-delay: 0s;
}
.voice-input-indicator .wave:nth-child(2) {
  animation-delay: 0.15s;
}
.voice-input-indicator .wave:nth-child(3) {
  animation-delay: 0.3s;
}
.voice-input-indicator .wave:nth-child(4) {
  animation-delay: 0.45s;
}
.voice-input-indicator .wave:nth-child(5) {
  animation-delay: 0.6s;
}
.voice-input-indicator .listening-text {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #133aa5;
}
.voice-input-indicator .listening-hint {
  margin: 0;
  font-size: 16px;
  color: #666;
  font-weight: 400;
}
.processing-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  animation: fadeIn 0.3s ease-in;
}
.processing-indicator .ai-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #1571b9;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.processing-indicator .ai-avatar i {
  font-size: 40px;
  color: white;
}
.processing-indicator .typing-indicator {
  display: flex;
  gap: 6px;
}
.processing-indicator .typing-indicator span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #133aa5;
  animation: typing 1.4s infinite;
}
.processing-indicator .typing-indicator span:nth-child(1) {
  animation-delay: 0s;
}
.processing-indicator .typing-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}
.processing-indicator .typing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}
.processing-indicator .processing-text {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #133aa5;
  text-align: center;
  max-width: 800px;
  word-wrap: break-word;
  line-height: 1.6;
  padding: 0 20px;
}
.processing-indicator .processing-text .word {
  display: inline-block;
  animation: wordFadeIn 0.3s ease-out;
}
.processing-indicator .processing-text .word .space {
  display: inline;
}
.subtitle-container {
  width: 100%;
  max-width: 900px;
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: auto;
  display: flex;
  justify-content: center;
  scroll-behavior: smooth;
}
.subtitle-container .subtitle-content {
  background: #ffffff;
  padding: 32px 40px;
  border-radius: 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: flex-start;
  gap: 16px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
  min-height: fit-content;
}
.subtitle-container .subtitle-content.speaking {
  background: #e3f2fd;
  border-left: 3px solid #133aa5;
  box-shadow: 0 2px 8px rgba(19, 58, 165, 0.2);
}
.subtitle-container .subtitle-content .subtitle-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #133aa5;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: iconPulse 1.5s infinite;
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.subtitle-container .subtitle-content .subtitle-icon i {
  font-size: 20px;
  color: white;
}
.subtitle-container .subtitle-content .subtitle-text {
  margin: 0;
  font-size: 24px;
  line-height: 1.6;
  color: #333;
  font-weight: 400;
  text-align: left;
  word-wrap: break-word;
  flex: 1;
  width: 100%;
}
.subtitle-container .subtitle-content .subtitle-text .word {
  display: inline-block;
}
.subtitle-container .subtitle-content .subtitle-text .word .space {
  display: inline;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #666;
  animation: fadeIn 0.5s ease-in;
}
.empty-state .empty-state-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #1571b9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(19, 58, 165, 0.3);
}
.empty-state .empty-state-icon i {
  font-size: 36px;
  color: white;
}
.empty-state h3 {
  font-size: 24px;
  margin: 0 0 8px 0;
  font-weight: 600;
  color: #333;
}
.empty-state p {
  font-size: 16px;
  margin: 0;
  color: #666;
}
.voice-control-panel {
  background: #ffffff;
  padding: 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.button-group {
  display: flex;
  align-items: center;
  gap: 16px;
}
.mic-button {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: none;
  background: #1571b9;
  color: white;
  font-size: 32px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(19, 58, 165, 0.4);
  transition: all 0.3s ease;
}
.mic-button:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(19, 58, 165, 0.6);
  background: #1a4bb8;
}
.mic-button:active:not(:disabled) {
  transform: scale(0.95);
}
.mic-button.recording {
  background: #d32f2f;
  animation: recordingPulse 1.5s infinite;
  box-shadow: 0 4px 16px rgba(211, 47, 47, 0.6);
}
.mic-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.clear-button {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: none;
  background: #666;
  color: white;
  font-size: 28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(102, 102, 102, 0.4);
  transition: all 0.3s ease;
}
.clear-button:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(102, 102, 102, 0.6);
  background: #777;
}
.clear-button:active:not(:disabled) {
  transform: scale(0.95);
}
.clear-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}
.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ccc;
  transition: all 0.3s ease;
}
.status-dot.active {
  background: #d32f2f;
  animation: statusPulse 1.5s infinite;
}
.status-dot.processing {
  background: #133aa5;
  animation: statusPulse 1.5s infinite;
}
.status-dot.speaking {
  background: #133aa5;
  animation: statusPulse 1.5s infinite;
}
.status-text {
  font-weight: 500;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes waveAnimation {
  0%, 100% {
    transform: scaleY(0.3);
  }
  50% {
    transform: scaleY(1);
  }
}
@keyframes typing {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.7;
  }
  30% {
    transform: translateY(-12px);
    opacity: 1;
  }
}
@keyframes recordingPulse {
  0%, 100% {
    box-shadow: 0 4px 16px rgba(211, 47, 47, 0.6);
  }
  50% {
    box-shadow: 0 4px 24px rgba(211, 47, 47, 0.9), 0 0 0 8px rgba(211, 47, 47, 0.2);
  }
}
@keyframes statusPulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
@keyframes subtitlePulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.01);
  }
}
@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}
@keyframes wordFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.page-title .icon {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.page-title .icon:hover {
  opacity: 0.8;
}
/*# sourceMappingURL=live-speak-assist.component.css.map */
